import React from 'react'
import { renderComponent} from '../helpers/RenderComponent'

/**
 * Lists all the rendered components
 * 
 */
function RenderedComponent(props) {
  const Myprops = props.value;


  /** Use given props to render component with renderComponent*/
  return (
    <>
        {renderComponent(Myprops)}
    </>
  )
}

export default RenderedComponent